import createCache, { EmotionCache } from "@emotion/cache";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";

// Separate keys keep LTR and RTL rules isolated during hydration and locale
// changes. Explicitly preserve vendor-prefixing when overriding Stylis plugins.
const createEmotionCache = (direction: "ltr" | "rtl" = "rtl"): EmotionCache =>
  createCache({
    key: `mui-${direction}`,
    stylisPlugins: direction === "rtl" ? [prefixer, rtlPlugin] : [prefixer],
  });

export { createEmotionCache };
